import { utilStyles } from '@Utils/utilStyles';
import { Text, View } from 'react-native';

export const MapPageLoading = () => (
  <View
    style={[
      utilStyles.height100pc,
      utilStyles.width100pc,
      utilStyles.alignItemsCenter,
      utilStyles.justifyContentCenter,
    ]}
  >
    <Text>...</Text>
  </View>
);
